<template>
  <div> 
    <b-container fluid>    
      <b-container style="padding-bottom: 64px; padding-top: 64px">
        <b-row align-h="center" align-v="center">
          <b-col cols="12" md="8">
            <h1 class="text-center" style="padding-bottom: 32px">Nefrite Lúpica</h1>

            <p class="text-justify">
              Você sabia que a Nefrite Lúpica é a principal doença que requer a realização de biópsia renal
              no serviço de Nefrologia da Hospital Universitário Onofre Lopes UFRN ? Apenas por este fato,
              já se justificaria priorizar o estudo das glomerulopatias por esta doença. Mas, é interessante
              perceber que o estudo da nefrite lúpica facilitará o estudo das demais glomerulopatias.
            </p>

            <h4 class="text-center">O que veremos nesse módulo:</h4>
            <ul class="list">
              <li v-for="item in conteudo" :key="item.id">{{item.description}}</li>
            </ul>

            <div class="text-center">
              <router-link to="/nefrite-lupica/capitulo-01" class="btn btn-primary">INICIE SEUS ESTUDOS</router-link>
              &nbsp;
              <router-link to="/nefrite-lupica/bibliografia" class="btn btn-primary">LITERATURA SUGERIDA</router-link>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      conteudo: [
        {
          id: 1,
          description: "Capítulo 1 – Introdução, diagnóstico e fisiopatologia"
        },
        {
          id: 2,
          description: "Capítulo 2 – Classes mesangiais"
        },
        {
          id: 3,
          description: "Capítulo 3 – Classes proliferativas"
        },
        {
          id: 4,
          description: "Capítulo 4 – Nefropatia membranosa lúpica"
        },
        {
          id: 5,
          description: "Capítulo 5 – Glomerulopatia crônica lúpica"
        }
      ]
    };
  }
};
</script>

<style scoped>
ul li {
  list-style-type: square;
  list-style-position: inside;
}
</style>